import React, { createContext, useContext, useState,useEffect } from "react";


const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {   
  const [dashboardToken, setDashboardToken] = useState("");   
  return (
    <GlobalContext.Provider value={{dashboardToken, setDashboardToken, }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);